<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="客户分析" />
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">客户总数</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.totalcustomers }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">销售总量</div>
                <div class="yesterday summaryLine">
                  <p>{{ summarizeData.totalsales }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">销售总额</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totalsalesmoney | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">总毛利</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totalnet_profit_fee | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">毛利率</div>
                <div class="summaryLine">
                  <p>
                    {{ (summarizeData.totalinterestrate * 100).toFixed(2) }}%
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
    </basicList>
  </div>
</template>


<script>
import { getcustomerlist } from "@/api/report";
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { itemClassGetList, getshoplist,customerGetList } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "customerAnalysis",
  data() {
    return {
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          // {
          //   label: "商品分类",
          //   type: "treeselect",
          //   options: [],
          //   key: "class_id",
          // },
          {
            label: "用户分类",
            type: "select",
            key: "type_id",
            options: [
              {
                value: 1,
                label: "同行",
              },
              {
                value: 2,
                label: "分销",
              },
              {
                value: 3,
                label: "团购",
              },
              {
                value: 4,
                label: "外卖",
              },
              {
                value: 5,
                label: "零售",
              },
            ],
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
          {
            label: "指定客户",
            type: "select",
            options: [],
            key: "customer_id",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,

          },
          {
            label: "客户",
            prop: "name",
            width: 250,
            fixed:"left"
          },
          {
            label: "类型",
            prop: "type_name",
            width: 180,
          },
          {
            label: "关联业务员",
            prop: "sale_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            sortable: true,
            width: 200,
          },
          {
            label: "交易金额",
            prop: "total_money",
            sortable: true,
            width: 200,
          },
          {
            label: "交易次数",
            prop: "salenum",
            sortable: true,
            width: 200,
          },
          {
            label: "交易瓶数",
            sortable: true,
            prop: "sale_num",
            width: 200,
          },
          {
            label: "交易毛利",
            prop: "net_profit_fee",
            sortable: true,
            width: 200,
          },
          {
            label: "毛利率",
            prop: "interestrate",
            sortable: true,
            width: 200,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      // 统计数据
      summarizeData: {
        totalcustomers: 0,
        totalinterestrate: 0,
        totalnet_profit_fee: 0,
        totalsales: 0,
        totalsalesmoney: 0,
      },
    };
  },
  created() {
    this.getData();
    this.obtainDataSource();
  },
  methods: {
    // 获取数据源
    obtainDataSource() {

      customerGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 排序方法
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getData();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    getData() {
      getcustomerlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list.map((item) => {
            item.total_money = this.$money(item.total_money);
            item.net_profit_fee = this.$money(item.net_profit_fee);
            item.interestrate = this.$multiplication(item.interestrate) + "%";
            return item;
          });
          for (const key in this.summarizeData) {
            this.summarizeData[key] = res[key];
          }
        } else {
          this.basicListconfig.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/customerAnalysis/index.vue